import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialOutlookIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialOutlook",
    children: /*#__PURE__*/_jsx("path", {
      d: "M18.44.01.52 3.41c-.3.06-.52.33-.52.64v23.88c0 .31.22.58.52.64l17.92 3.4s.08.02.12.02c.15 0 .28-.05.4-.14a.65.65 0 0 0 .24-.5V.63a.65.65 0 0 0-.24-.5c-.15-.12-.33-.16-.52-.12m2.04 7.02v7.78l1.12.92 9.76-5.82V7.67c0-.35-.28-.64-.64-.64zM9.5 9.93c1.52 0 2.76.55 3.7 1.64s1.4 2.52 1.4 4.3-.48 3.32-1.46 4.44-2.23 1.7-3.8 1.7-2.78-.55-3.74-1.64-1.44-2.51-1.44-4.26c0-1.85.48-3.34 1.46-4.48s2.27-1.7 3.88-1.7m21.86 1.48-9.48 5.66c-.1.06-.23.08-.34.08-.15 0-.28-.04-.4-.14l-.66-.54v7.84h1.32a5.13 5.13 0 0 0 5.08 5.76c2.82 0 5.12-2.3 5.12-5.12 0-.91-.25-1.76-.66-2.5 0-.02.02-.04.02-.06zm-21.92.78c-.84 0-1.53.35-2.02 1.04-.5.69-.74 1.6-.74 2.74s.24 2.09.74 2.76 1.15 1 1.96 1 1.47-.33 1.96-.98c.48-.65.74-1.56.74-2.72s-.23-2.15-.7-2.82c-.47-.68-1.12-1.02-1.94-1.02m17.44 8.92a3.841 3.841 0 0 1 0 7.68 3.841 3.841 0 0 1 0-7.68m-.64.64v4.48h3.2v-1.28h-1.92v-3.2z"
    })
  }));
};
SocialOutlookIcon.displayName = 'SocialOutlookIcon';